import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[workflowApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[workflowApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    // GET /api/workflow/{entity}/{id}/transitions/available/
    async getAvailableTransitions(entity, id) {
        try {
            const res = await axiosInstance.get(`workflow/${entity}/${id}/transitions/available/`);
            return res.data; // { current_state, available: WorkflowState[] }
        } catch (e) {
            logAndRethrow(`GET workflow/${entity}/${id}/transitions/available/`, e);
        }
    },

    // GET /api/workflow/{entity}/{id}/status-history/
    async getStatusHistory(entity, id) {
        try {
            const res = await axiosInstance.get(`workflow/${entity}/${id}/status-history/`);
            return res.data; // TransitionHistory[]
        } catch (e) {
            logAndRethrow(`GET workflow/${entity}/${id}/status-history/`, e);
        }
    },

    // POST /api/workflow/{entity}/{id}/transition/
    async doTransition(entity, id, { to_state, reason } = {}) {
        try {
            const res = await axiosInstance.post(`workflow/${entity}/${id}/transition/`, { to_state, reason });
            return res.data; // 204 no content by spec, axios.data may be empty
        } catch (e) {
            logAndRethrow(`POST workflow/${entity}/${id}/transition/`, e);
        }
    },
};